package com.speedsoftware.nibbler.ui.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.unit.Dp
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi
import org.jetbrains.compose.resources.decodeToImageBitmap

private val renderedEmoji = HashMap<String, ImageBitmap>()

/** Draws [emoji] on a canvas element using the system emoji font (Apple, Segoe, Noto, ...) and returns a PNG data URL. */
private fun renderEmojiDataUrl(emoji: String, px: Int): String {
    val render: dynamic = js(
        "(function (e, px) {" +
            "var c = document.createElement('canvas'); c.width = px; c.height = px;" +
            "var x = c.getContext('2d'); x.textAlign = 'center'; x.textBaseline = 'middle';" +
            "x.font = Math.round(px * 0.8) + 'px \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Noto Color Emoji\", sans-serif';" +
            "x.fillText(e, px / 2, px / 2 + px * 0.05);" +
            "return c.toDataURL('image/png');" +
            "})"
    )
    return render(emoji, px) as String
}

@OptIn(ExperimentalEncodingApi::class)
@Composable
actual fun EmojiGlyph(emoji: String, size: Dp, modifier: Modifier) {
    // Render at the screen's pixel density so the emoji stays sharp
    val px = with(LocalDensity.current) { size.roundToPx() }.coerceAtLeast(8)
    val key = "$emoji@$px"
    var bitmap by remember(key) { mutableStateOf(renderedEmoji[key]) }

    LaunchedEffect(key) {
        if (bitmap == null) {
            val decoded = runCatching {
                Base64.decode(renderEmojiDataUrl(emoji, px).substringAfter(",")).decodeToImageBitmap()
            }.getOrNull()
            if (decoded != null) {
                renderedEmoji[key] = decoded
                bitmap = decoded
            }
        }
    }

    Box(modifier = modifier.size(size), contentAlignment = Alignment.Center) {
        bitmap?.let { Image(bitmap = it, contentDescription = null, modifier = Modifier.size(size)) }
    }
}
